export default __webpack_public_path__ + "static/media/team51.48574ed3.JPG";